import React, { useEffect, useState } from 'react';

// core components
import CustomTabs from 'components/CustomTabs/CustomTabs.js';
import OccupancyRateGroup from 'components/Slots/OccupancyRateGroup';
import PermanencyRateGroup from 'components/Orders/PermanencyRateGroup';
import SendAndCollect from 'components/Orders/SendAndCollectGroup';
import DropdownGroup from 'components/Dropdown/DropdownGroup';
import Operacoes from 'views/Relatorios/RelatoriosOperacoes';
import { createBrowserHistory } from "history";

import { getAllLockers } from '../../services/lockers/lockers';
import { getUser } from "../../services/users/users";
import { getAllLockersSelect } from "../../services/lockers/lockers";

const RelatoriosFabrika = () => {
  if (!localStorage.getItem("user")) {
    createBrowserHistory({ forceRefresh: true }).push("/");
  } else {
    createBrowserHistory({ forceRefresh: false }).push(`/`);
  }

  const lockerId = localStorage.getItem('lockerId');
  const currentUser = JSON.parse(localStorage.getItem("user"));

  const [lockersId, setLockersId] = useState([]);
  const [lockersName, setLockersName] = useState([]);
  const [selected, setSelected] = useState('Todos');
  const [groups, setGroups] = useState([]);
  const [lockers, setLockers] = useState([]);
  const [groupedLockers, setGroupedLockers] = useState({});

  useEffect(() => {
    getLockers();
  }, []);

  const getLockers = async () => {
    //await getUser(currentUser.data.id, async (us) => {
    await getAllLockersSelect(async (us) => {

      let groupedLocker = {};

      us.listGrupos.push({
        value: null,
        label: "Todos",
      });

      us.listLockers.push({
        value: null,
        label: "Todos",
      });

      await us.listGrupos.forEach(g => {
        groupedLocker[g.label] = [];
      });

      await getAllLockers((data) => {
        const lockersName = data.map((locker) => {
          if (groupedLocker[locker.group_lockers]) {
            groupedLocker[locker.group_lockers].push(`- ${locker.name} \n\n`);
          }

          return locker.name;
        });

        setLockersName(lockersName);
        const lockersId = data.map((locker) => locker.id);
        setLockersId(lockersId);
        setGroupedLockers(groupedLocker);
        setGroups(us.listGrupos);
        setLockers(us.listLockers);
      });
    });

  };

  return (
    <div style={{ display: 'flex' }}>
      <CustomTabs
        // title="Relatórios:"
        headerColor="primary"
        tabs={[
          {
            tabName: 'TAXA DE OCUPAÇÃO',
            tabContent: <OccupancyRateGroup key={selected} data={[]} />,
          },
          {
            tabName: 'TAXA DE PERMANÊNCIA',
            tabContent: <PermanencyRateGroup key={selected} lockerId={lockerId} />,
          },
          {
            tabName: 'ENTREGAS E RETIRADAS',
            tabContent: <SendAndCollect key={selected} lockers={lockers} />
          },
          {
            tabName: 'OPERAÇÕES',
            tabContent: (
              <Operacoes
                key={selected}
                lockerId={lockerId}
                allIDs={lockersId}
                allNames={lockersName}
                selected={selected}
                groups={groups}
                lockers={lockers}
                groupedLockers={groupedLockers}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default RelatoriosFabrika;
